module.exports = __webpack_public_path__ + "assets/img/414_main_img_carousel_1.7804f9b0.png";